import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { server_url } from "../../Config/API";

const STATS = [
  { key: "user",   label: "Happy Patients",     icon: "solar:user-heart-bold-duotone",         color: "bg-sky-500/10 text-sky-400"     },
  { key: "doctor", label: "Expert Doctors",      icon: "solar:stethoscope-bold-duotone",         color: "bg-emerald-500/10 text-emerald-400" },
  { key: "city",   label: "Cities Covered",      icon: "solar:map-point-bold-duotone",           color: "bg-violet-500/10 text-violet-400" },
  { key: "awards", label: "Awards & Recognition",icon: "solar:medal-ribbons-star-bold-duotone",  color: "bg-amber-500/10 text-amber-400" },
];

const State = () => {
  const [counts, setCounts] = useState({ doctor: 0, user: 0 });
  const [data, setData]     = useState({});

  useEffect(() => {
    fetch(`${server_url}/user/dashboard-counts`)
      .then((r) => r.json())
      .then((d) => { if (d?.status === "success") setCounts(d.data); })
      .catch(console.error);
  }, []);

  useEffect(() => {
    fetch(`${server_url}/homeState/getHomeState`)
      .then((r) => r.json())
      .then((d) => { if (d?.data?.length) setData(d.data[0]); });
  }, []);

  const getValue = (key) => {
    if (key === "user")   return counts?.user   || 0;
    if (key === "doctor") return counts?.doctor || 0;
    if (key === "city")   return data?.city     || 0;
    if (key === "awards") return data?.awards   || 0;
    return 0;
  };

  return (
    <section className="bg-dark-gradient py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Label */}
        <p className="text-center text-xl font-semibold text-indigo-400 uppercase tracking-[0.2em] mb-3 font-sans">
          Our Impact
        </p>
        <p className="text-center text-white/30 text-sm mb-14 font-sans">
          Delivering measurable outcomes across Bangladesh
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {STATS.map((s) => (
            <div
              key={s.key}
              className="relative group rounded-2xl border border-gray-700 bg-white/5 hover:bg-white/10 transition-colors duration-300 p-7 flex flex-col items-start gap-4 overflow-hidden"
            >
              {/* Glow on hover */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-radial-[ellipse_60%_50%_at_50%_50%] from-indigo-900/20 to-transparent pointer-events-none" />

              <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${s.color}`}>
                <Icon icon={s.icon} className="w-6 h-6" />
              </div>

              <div>
                <p className="font-heading text-4xl font-extrabold text-white tracking-tight leading-none">
                  {getValue(s.key).toLocaleString()}
                  <span className="text-indigo-400 ml-0.5">+</span>
                </p>
                <p className="mt-2 text-sm font-medium text-gray-400 font-sans">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default State;
